export default () => ({
  paymentWrapper: {
    width: '30vw',
    maxWidth: 590,
    alignSelf: 'center',
  },
  paymentMessage: {
    fontSize: 14,
    lineHeight: '20px',
    paddingTop: 12,
  },
  paymentElement: {
    margin: '25px 0 10px',
  },
  submitPaymentButton: {
    background: '#5469d4',
    fontFamily: 'Arial, sans-serif',
    color: '#ffffff',
    borderRadius: 4,
    border: 0,
    padding: '12px 16px',
    fontSize: 16,
    fontWeight: 600,
    cursor: 'pointer',
    display: 'block',
    transition: 'all 0.2s ease',
    boxShadow: '0px 4px 5.5px 0px rgba(0, 0, 0, 0.07)',
    width: '100%',
    '&:hover': {
      filter: 'contrast(115%)',
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'default',
    },
  },
  spinner: {
    borderRadius: '50%',
    color: ' #ffffff',
    fontSize: 22,
    textIndent: '-99999px',
    margin: '0px auto',
    position: 'relative',
    width: 20,
    height: 20,
    boxShadow: 'inset 0 0 0 2px',
    WebkitTransform: 'translateZ(0)',
    MSTransform: 'translateZ(0)',
    transform: 'translateZ(0)',
    '&:before': {
      position: 'absolute',
      content: '',
      width: 10.4,
      height: 20.4,
      background: '#5469d4',
      borderRadius: '20.4px 0 0 20.4px',
      top: -0.2,
      left: -0.2,
      WebkitTransformOrigin: '10.4px 10.2px',
      transformOrigin: '10.4px 10.2px',
      WebkitAnimation: 'loading 2s infinite ease 1.5s',
      animation: 'loading 2s infinite ease 1.5s',
    },
    '&:after': {
      position: 'absolute',
      content: '',
      width: 10.4,
      height: 10.2,
      background: '#5469d4',
      borderRadius: '0 10.2px 10.2px 0',
      top: -0.1,
      left: 10.2,
      WebkitTransformOrigin: '0px 10.2px',
      transformOrigin: '0px 10.2px',
      WebkitAnimation: 'loading 2s infinite ease',
      animation: 'loading 2s infinite ease',
    },
  },
  '@keyframes check': {
    '0%': {
      WebkitTransform: 'rotate(0deg)',
      transform: 'rotate(0deg)',
    },
    '100%': {
      WebkitTransform: 'rotate(360deg)',
      transform: 'rotate(360deg)',
    },
  },
  '@media only screen and (max-width: 600px)': {
    paymentWrapper: {
      width: '80vw',
      minWidth: 'initial',
    },
  },
});
